import { render, staticRenderFns } from "./custom-modal-component.vue?vue&type=template&id=d8d9b86c&scoped=true"
import script from "./custom-modal-component.vue?vue&type=script&lang=js"
export * from "./custom-modal-component.vue?vue&type=script&lang=js"
import style0 from "./custom-modal-component.vue?vue&type=style&index=0&id=d8d9b86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d9b86c",
  null
  
)

export default component.exports